import './selecionarPrecificador.css';
import { useState,useEffect,useContext} from 'react';
import {IoClose} from 'react-icons/io5';
import {AuthContext} from '../../contexts/auth';
import api, { apiUrl } from '../../services/api';
import {toast} from 'react-toastify';
import InputPesquisa from '../InputPesquisa';
import Alcool from '../../img/alcool.png';

export default function SelecionarPrecificador({pedido,formato,campanha,fechar}){
    const formatosComPrecoDePor = [4, 5, 29, 30, 38, 61];
    const exibeDePor = formatosComPrecoDePor.includes(Number(formato));


    const formatosCampanhaComPrecoEditaveis = [
        { name: 'A4 Swift em dobro', id: 6 },
        { name: 'Etiqueta Swift em dobro', id: 7 },
        { name: 'Cavalete Swift em dobro', id: 8 },
        { name: 'A3 Swift em dobro', id: 13 },
        { name: 'A4 Aniversário Dois Por menos', id: 17 },
        { name: 'Etiquetas Aniversário Dois Por menos', id: 18 },
        { name: 'A3 Aniversário Dois Por menos', id: 19 },
        { name: 'A4 Black friday Dois Por menos', id: 23 },
        { name: 'A3 Black friday Dois Por menos', id: 24 },
        { name: 'Etiquetas Black friday Dois Por menos', id: 25 },
        { name: 'A4 Natal Dois Por Menos', id: 46 },
        { name: 'A3 Natal Dois Por Menos', id: 47 },
        { name: 'Etiquetas Natal Dois Por Menos', id: 48 },
        { name: 'A5 Natal Dois Por Menos', id: 50 },
        { name: 'A4 Natal (Apenas Texto) Dois Por Menos', id: 56 },
        { name: 'A3 Natal (Apenas Texto) Dois Por Menos', id: 57 },
        { name: 'Etiquetas Natal (Apenas Texto) Dois Por Menos', id: 58 },
        { name: 'A5 Natal (Apenas Texto) Dois Por Menos', id: 60 },
    ]


    const formatosCampanhaComPrecoEditaveisSelecionado = formatosCampanhaComPrecoEditaveis.find(dataFormatos => dataFormatos.id == formato);

    // Kit Completo (64 a 67) e Kit Completo Natal (68 a 71): cada item do pedido é um kit,
    // com composição, valor (preço regular) e validade editáveis pela loja
    const formatosKit = [64, 65, 66, 67, 68, 69, 70, 71];
    const isKit = formatosKit.includes(Number(formato));
    const LIMITE_COMPOSICAO = 255;
    const [kitEdicao, setKitEdicao] = useState({});

    const validadeParaInput = (validade) => validade ? validade.split('/').reverse().join('-') : '';
    const validadeParaTexto = (validade) => validade ? validade.split('-').reverse().join('/') : '';

    const valorKit = (item, campo) => {
        const editado = kitEdicao[item.id]?.[campo];
        if (editado !== undefined) return editado;
        if (campo === 'preco') return Number(item.preco_regular) > 0 ? item.preco_regular : '';
        if (campo === 'composicao') return item.kit_composicao || '';
        return validadeParaInput(item.kit_validade);
    }

    const alteraCampoKit = (itemId, campo, valor) => {
        setKitEdicao((atual) => ({ ...atual, [itemId]: { ...atual[itemId], [campo]: valor } }));
    }

    //CATEGORIA
    const [categoriaSelecionada,setCategoriaSelecionada] = useState('0');
    const [categoria,setCategoria] = useState([]);
    
    //Lista de produtos
    const [listaP,setListaP] = useState([])
    const [listaPFiltrada, setListaPFiltrada] = useState([]);
    
    //ITENS SELECIONADOS
    const [selecionados,setSelecionados] = useState([]);
    const handleSelect = function(selectedItems) {
        const select = [];
        for (let i=0; i<selectedItems.length; i++) {
            select.push(selectedItems[i].value);
        }
        setSelecionados(select);
    }

    //ITENS DO PEDIDO
    const [produtosP, setProdutosP] = useState('');
    const [precoNovo,setPrecoNovo] = useState('')
    const [precoNovoPromocional, setPrecoNovoPromocional] = useState("")

    //Numero de paginas
    const [, setPaginas] = useState(0);

    //Loja
    const [jLoja,setJloja] = useState(JSON.parse(localStorage.getItem('dataLoja')));
    const [load,setLoad] = useState(false);
    const {user,signOut} = useContext(AuthContext);

    const [loadingPdf, setLoadingPdf] = useState(false)
    const [gerarPdf, setGerarPdf] = useState(true)

    //BUSCA PRODUTOS DO VAREJISTA
    async function getProdutos(){
        if(categoriaSelecionada !== '0'){
            setLoad(true)
            await api.get(`/produtos/categoria/${categoriaSelecionada}`,
                {
                    headers:{'Authorization':user.token},
                    params:{
                        formato: formato,
                        varejo:jLoja.varejo,
                        preco:jLoja.preco,
                        campanhaId: pedido.campanhaId,
                        pedido:pedido.id
                    }
                }
            ).then((resp)=>{
                setListaP(resp.data.produtos)
                setListaPFiltrada(resp.data.produtos)
                setLoad(false)
            }).catch((error)=>{
                if(error.response.status === 401){
                    toast.info(error.response.data.error)
                    signOut()
                }else{
                    setListaP([])
                    setListaPFiltrada([])
                    toast.error(error.response.data.error)
                    setLoad(false)
                }
            })
        }else{
            setLoad(true)
            await api.get('/produtos/varejo',
                {
                    headers:{'Authorization':user.token},
                    params:{
                        formato: formato,
                        varejo:jLoja.varejo,
                        preco:jLoja.preco,
                        campanhaId: campanha ? campanha.id : 0,
                        pedido:pedido.id
                    }
                },
            ).then((resp)=>{
                setListaP(resp.data.produtos)
                setListaPFiltrada(resp.data.produtos)
                setLoad(false)
            }).catch((error)=>{
                if(error.response.status === 401){
                    toast.info(error.response.data.error)
                    signOut()
                }else{
                    setListaP([])
                    setListaPFiltrada([])
                    toast.error(error.response.data.error)
                    setLoad(false)
                }
            })
        }
    }
    const buscaProdutos = async () => {
        setGerarPdf(true)
        
        try {
            const resp = await api.get(`/produtos_pedido/${pedido.id}`,
                {
                    headers:{'Authorization':user.token},
                    params: {
                        varejo:jLoja.varejo,
                        preco:jLoja.preco,
                        campanhaId: pedido.campanhaId
                    }
                }
            )
            
            setProdutosP(resp.data.produtos)
            setPaginas(resp.data.quantidade)
            setLoad(false)
        }
        catch (error) {
            if(error.response.status === 401){
                toast.info(error.response.data.error)
                signOut()
            }else{
                toast.info(error.response.data.error)
                setProdutosP('')
                setLoad(false)
            }
        }
    }

    useEffect(()=>{
        setJloja(JSON.parse(localStorage.getItem('dataLoja')))
        //BUSCA CATEGORIAS
        async function getCategorias(){
            setLoad(true)
            await api.get('/categorias',
                {
                    headers:{'Authorization':user.token}
                }
            ).then((resp)=>{
                let json = resp.data
                setCategoria(json.categorias.map((v,k)=>{
                    return <option key={k} value={v.id}>{v.categoria}</option>
                }))
                setLoad(false)
            }).catch((error)=>{
                if(error.response.status === 401){
                    toast.info(error.response.data.error)
                    signOut()
                }else{
                    toast.error(error.response.data.error)
                    setLoad(false)
                }
            })
        }
        buscaProdutos()
        getCategorias()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[user.token,signOut])

    useEffect(() => {
        if (pedido?.id) getProdutos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pedido,user.token,signOut,categoriaSelecionada])

    async function criaPDF(){
        let retornarToast = true
        if(loadingPdf){
            return
        }

        if(!gerarPdf){
            return window.open(`${apiUrl}/uploads/ID${pedido.id}.pdf`, "_blank", "noreferrer");
        }

        if(isKit && produtosP !== ''){
            const incompletos = produtosP
                .map((item, idx) => ({
                    numero: idx + 1,
                    faltando: [
                        !String(item.kit_composicao || '').trim() && 'composição',
                        !(Number(item.preco_regular) > 0) && 'valor',
                        !String(item.kit_validade || '').trim() && 'validade'
                    ].filter(Boolean)
                }))
                .filter((kit) => kit.faltando.length > 0)

            if(incompletos.length > 0){
                return toast.warning(
                    <>
                        Preencha e salve os kits antes de gerar o PDF:
                        {incompletos.map((kit) => <span key={kit.numero}><br />Kit {kit.numero}: {kit.faltando.join(', ')}</span>)}
                    </>
                )
            }
        }

        setLoadingPdf(true)
        if(produtosP !== ''){
            const itensPedido = []
            for(let i=0;i<produtosP.length;i++){

                if(formato === 8 && (produtosP[i].descricao.length > 27 || produtosP[i].descricao2.length > 30)){
                    setLoadingPdf(false)
                    return toast.warning(
                        <>
                          {produtosP[i].descricao} limite de caracteres maior que o permitido
                          <br />
                          Descrição 1: 27 caracteres
                          <br />
                          Descrição 2: 30 caracteres
                        </>
                      );
                }
                
                // if((formato == 6 || formato == 7) && Number(produtosP[i].preco_regular) <= 0){
                //     setLoadingPdf(false)
                //     return toast.warning(<>
                //         {produtosP[i].descricao} 
                //         <bold> sem preço regular</bold> cadastrado, favor cadastre valor nesse campo
                //         </>
                //       )
                // }

                // if(((formato == 7) && ((produtosP[i].descricao.length + produtosP[i].descricao2.length) > 50))){
                //     setLoadingPdf(false)
                //     return toast.warning(
                //         <>
                //           {produtosP[i].descricao} limite de caracteres maior que o permitido
                //           <br />
                //           Descrição 1: 36 caracteres
                //           <br />
                //           Descrição 2: 36 caracteres
                //         </>
                //       );
                // }

                if(((formato === 6) && (produtosP[i].descricao.length > 36 || produtosP[i]?.descricao2?.length > 36))){
                    setLoadingPdf(false)
                    return toast.warning(
                        <>
                          {produtosP[i].descricao} limite de caracteres maior que o permitido
                          <br />
                          Descrição 1: 36 caracteres
                          <br />
                          Descrição 2: 36 caracteres
                        </>
                      );
                }

                if(isKit ? Number(produtosP[i].preco_regular) > 0 : produtosP[i].preco > 0){
                    itensPedido.push({
                        ...(isKit ? { kit_composicao: produtosP[i].kit_composicao, kit_validade: produtosP[i].kit_validade } : {}),
                        descricao:produtosP[i].descricao,
                        descricao2:produtosP[i].descricao2,
                        preco:String(produtosP[i].preco),
                        preco_promocional:String(produtosP[i].preco_promocional),
                        preco_regular: String(produtosP[i].preco_regular),
                        preco_unidade_1: String(produtosP[i].preco_unidade_1),
                        preco_unidade_2: String(produtosP[i].preco_unidade_2),
                        preco_unidade_3: String(produtosP[i].preco_unidade_3),
                        peso:produtosP[i].peso,
                        codigo:produtosP[i].codigo,
                        frase_destaque: produtosP[i].frase_destaque,
                        frase_destaque_rodape: produtosP[i].frase_destaque_rodape,
                        unidade_de_medida_promocional: produtosP[i].unidade_de_medida_promocional,
                        vigencia: produtosP[i].vigencia,
                        alcoolico: produtosP[i].alcoolico,
                        categoria:produtosP[i].categoria
                    })
                }
                else if(retornarToast){
                    retornarToast = false
                    toast.info('CONTÉM ITENS SEM PREÇO PARA A SUA LOJA.')
                }
            }
            await api.post('/pdf/precificador',
                {
                    listaProdutos:itensPedido,
                    pedido_id:pedido.id,
                    formato:formato,
                    loja:jLoja.nome,
                    nome:jLoja.liderSenior,
                    contato:jLoja.telefoneS,
                    endereco:jLoja.endereco,
                    bairro:jLoja.bairro,
                    cep:jLoja.cep,
                    cidade:jLoja.cidade,
                    estado:jLoja.estado,
                },
                {
                    headers:{'Authorization':user.token}
                }
            ).then((resp)=>{
                setLoad(false)
                setTimeout(() => {
                    window.open(`${apiUrl}/uploads/ID${pedido.id}.pdf`, "_blank", "noreferrer");
                    setLoadingPdf(false)
                    setGerarPdf(false)
                }, 3000)
            }).catch((error)=>{
                setLoadingPdf(false)
                if(error.response?.status === 401){
                    toast.info(error.response.data.error)
                    signOut()
                }else{
                    toast.info(error.response.data.error)
                    setLoad(false)
                }
            })
        }
    }

    //ADICIONA iTEM AO PEDIDO
    async function adicionaItem(){
        setGerarPdf(true)
        if(selecionados.length !== 0){
            setLoad(true)
            let itens = []
            const listaBusca = listaPFiltrada.length > 0 ? listaPFiltrada : listaP
            for(let i=0;i < selecionados.length;i++){
                const idBuscado = Number(selecionados[i]) || selecionados[i]
                let produtoEncontrado = listaBusca.find(p => p.id === idBuscado || p.id === selecionados[i])
                if(!produtoEncontrado){
                    toast.error(`Produto não encontrado na lista. Tente recarregar e selecionar novamente.`)
                    setLoad(false)
                    return
                }
                itens.push({
                    id_produto: selecionados[i],
                    precoOficial:produtoEncontrado.preco,
                    precoRegular: produtoEncontrado?.preco_regular,
                    preco_unidade_1: produtoEncontrado?.preco_unidade_1,
                    preco_unidade_2: produtoEncontrado?.preco_unidade_2,
                    preco_unidade_3: produtoEncontrado?.preco_unidade_3,
                    id_pedido:pedido.id
                })
            }
            //Adiciona itens
            await api.post('/produtos_pedido',
                {
                    relacionamentos:itens
                },
                {
                    headers:{'Authorization': user.token}
                }
            ).then((resp)=>{
                toast.success(resp.data.mensagem)
                setSelecionados([])
            }).catch((error)=>{
                if(error.response.status === 401){
                    toast.info(error.response.data.error)
                    signOut()
                }else{
                    toast.info(error.response.data.error)
                    setLoad(false)
                }
            })

            await buscaProdutos();
        }else{
            toast.info('Nenhum item selecionado')
        }
        setLoad(false)   
    }

    //salva composição, valor e validade de um kit (formatos Kit Completo)
    async function salvaKit(item){
        setGerarPdf(true)
        setLoad(true)

        const body = {
            preco_regular: valorKit(item, 'preco') ? String(valorKit(item, 'preco')) : undefined,
            kit_composicao: valorKit(item, 'composicao').slice(0, LIMITE_COMPOSICAO),
            kit_validade: validadeParaTexto(valorKit(item, 'validade'))
        }

        try {
            const resp = await api.patch(`/produtos_pedido/${item.id}`, body, { headers:{'Authorization':user.token} })
            toast.success(resp.data.mensagem)
            setKitEdicao((atual) => {
                const { [item.id]: _, ...resto } = atual
                return resto
            })
            await buscaProdutos()
        } catch (error) {
            if(error.response?.status === 401){
                toast.info(error.response.data.error)
                signOut()
            }else{
                toast.info(error.response?.data?.error || 'Erro ao salvar o kit')
            }
        }
        setLoad(false)
    }

    //altera preco executado
    async function alteraPrecoExecutado(itemId,itemPreco,precoPromocional){
            setGerarPdf(true)
            setLoad(true)

            const body = {}

            if(formatosCampanhaComPrecoEditaveisSelecionado){
                body.preco_regular = itemPreco
            }else{
                body.preco = itemPreco
                body.preco_promocional = precoPromocional
            }

            await api.patch(`/produtos_pedido/${itemId}`,
                {
                    ...body,
                },
                {
                  headers:{'Authorization':user.token}
                }
            ).then((resp)=>{
                toast.success(resp.data.mensagem)
            }).catch((error)=>{
                if(error.response.status === 401){
                    toast.info(error.response.data.error)
                    signOut()
                }else{
                    toast.info(error.response.data.error)
                    setLoad(false)
                }
            })
            //busca itens do pedido
            await api.get(`/produtos_pedido/${pedido.id}`,
                {
                    headers:{'Authorization':user.token}
                }
            )
            .then((resp)=>{
                if(resp.data.produtos.length === 0){
                    setProdutosP('')
                    setPaginas(resp.data.quantidade)
                    setLoad(false)
                }else{
                    setProdutosP(resp.data.produtos)
                    setPrecoNovo('')
                    setPrecoNovoPromocional('')
                    setPaginas(resp.data.quantidade)
                    setLoad(false)
                }
            }).catch((error)=>{
                if(error.response.status === 401){
                    toast.info(error.response.data.error)
                    signOut()
                }else{
                    toast.info(error.response.data.error)
                    setProdutosP('')
                    setLoad(false)
                }
            })
            setLoad(false)
    }
    //Remove item do pedido
    async function removeItem(itemId){
        setGerarPdf(true)
        setLoad(true)
        await api.delete('/produtos_pedido',
            {
            params:
            {
                produto_id:itemId,
                pedido_id:pedido.id
            },
            headers:{'Authorization':user.token}
            }
        ).then((resp)=>{
            toast.success(resp.data.mensagem)
        }).catch((error)=>{
            if(error.response.status === 401){
                toast.info(error.response.data.error)
                signOut()
            }else{
                toast.info(error.response.data.error)
                setLoad(false)
            }
        })
        await buscaProdutos();
        setLoad(false)
    }

    if(load === true || loadingPdf === true){
        return(
            <div className='modalPrecificador'>
                <div className='modalPrecificador-container'>
                    <h1>Carregando...</h1>
                </div>
            </div>
        )
    }

    function filtroDeProdutos(lista, valor){
        return lista.filter((produto) => produto.produto.toUpperCase().includes(valor.toUpperCase()));
    }

    function validarProduto(item){
        if(formato == 6 || formato == 7){
            return item.frase_destaque
        }else if(formato == 14 || formato == 15 || formato == 16 || formato == 31){
            return item.preco_unidade_1 != "0" && item.preco_unidade_1 != null && item.preco_unidade_2 != "0" && item.preco_unidade_2 != null && item.preco_unidade_3 != "0" && item.preco_unidade_3 != null
        }
        return true
    }

    console.log(produtosP)

    return(
        <div className='modalPrecificador'>
            <div className='modalPrecificador-fechar'>
                <button onClick={fechar} className='modalPrecificador-btn-fechar'>
                    <IoClose size={30} color='#FFF'/>
                </button>
            </div>
            <div className='modalPrecificador-container'>
                <div>
                    <h1>Adicionar Itens</h1>
                    <div className='modalPrecificador-componentes'>
                        <div className='adicionar-itens-header'>
                            <div className='pesquisar-container'>
                                <h3>Pesquisar</h3>
                                <div className='input-pesquisa-container'>
                                    <InputPesquisa lista={listaP} setLista={setListaPFiltrada} funcaoDeFiltro={filtroDeProdutos}/>
                                </div>
                            </div>
                            <div className='sel-categoria-container'>
                                <h3>Categoria</h3>
                                <select className='sel-categoria' value={categoriaSelecionada} multiple={false} onChange={(e)=>{setCategoriaSelecionada(e.target.value)}}>
                                    <option key={0} value={0}>SELECIONAR</option>
                                    {categoria}
                                </select>
                            </div>
                        </div>
                        <div className='sel-produto-container'>
                            <h3>Selecione os Produtos</h3>
                            <select className='sel-produto' value={selecionados} size='5' multiple={true} onChange={(e)=>{handleSelect(e.target.selectedOptions)}}>
                                {listaPFiltrada.map((produto)=>{
                                    return <option key={produto.id} value={produto.id}>{produto.produto}</option>
                                })}
                            </select>
                        </div>
                        <div className='modalPrecificador-button'>
                            <button onClick={adicionaItem}>ADICIONAR</button>
                            <button onClick={()=>setSelecionados([])}>LIMPAR</button>
                        </div>
                        <div className='modalPrecificador-button1'>
                            <button type="button" className="link-button" onClick={() => criaPDF()}>DOWNLOAD PDF</button>
                        </div>
                    </div>
                </div>
                <div className='modalPrecificador-preview'>
                    <h1>Itens Selecionados</h1>
                    {produtosP !== '' ? 
                     (
                        <div className='modalPrecificador-preview-itens'>
                            {produtosP.map((item)=>{
                                if(item.preco){
                                    item.preco = Number(item.preco).toFixed(2)
                                    item.preco_promocional = Number(item.preco_promocional).toFixed(2)
                                    item.preco_regular = Number(item.preco_regular).toFixed(2)
                                    const prod = listaP.find((produto) => produto.id === item.produtoId);
                                    return(
                                        <div
                                            className='modalPrecificador-preview-container'
                                            key={item.id}
                                        >
                                            <div className={'modalPrecificador-preview-areaItem' + (!validarProduto(item) ? " naoAprovado" : "")}>
                                                {(formato != 12 && formato != 14 && formato != 15 && formato != 16 && formato != 31 && formato != 29 && formato != 32 && formato != 33 && formato != 34 && formato != 35 && formato != 36 && formato != 38) && item.frase_destaque && <h1 className='fraseDestaque'>{item.frase_destaque}</h1>}
                                                <h1>{item.descricao}</h1>
                                                <h2>{item.descricao2}</h2>
                                                {(formato === 6 || formato === 7)  && <h4 className='frase_promocional'>{item.unidade_de_medida_promocional}</h4>}
                                                {formato === 8 && <h4 className='frase_promocional'>O KG SAI POR:</h4>}
                                                {item.alcoolico === 1 && <img className='alcool' src={Alcool} alt="" />}
                                                
                                                {isKit ? (
                                                <div className='item-baixo'>
                                                    {Number(item.preco_regular) > 0 ? (
                                                        <>
                                                            <h3>{item.preco_regular.toString().slice(0,-3)},</h3>
                                                            <h4>{item.preco_regular.toString().slice(-2)}</h4>
                                                        </>
                                                    ) : <h3>SEM VALOR</h3>}
                                                </div>
                                                ):
                                                (formato == 14 || formato == 15 || formato == 16 || formato == 31) ? (

                                                <div className={``}>
                                                    <h2>1 Un.: {Number(item.preco_unidade_1).toFixed(2).toString().slice(0,-3)},{Number(item.preco_unidade_1).toFixed(2).toString().slice(-2)}</h2>
                                                    <h2>2 Un.: {Number(item.preco_unidade_2).toFixed(2).toString().slice(0,-3)},{Number(item.preco_unidade_2).toFixed(2).toString().slice(-2)}</h2>
                                                    <h2>3 Un.: {Number(item.preco_unidade_3).toFixed(2).toString().slice(0,-3)},{Number(item.preco_unidade_3).toFixed(2).toString().slice(-2)}</h2>
                                                </div>   
                                                ):
                                                (formato == 29 || formato == 30) ? (
                                                    <div className={`item-baixo ${exibeDePor ? " diminuir" : ""}`}>
                                                        {exibeDePor ? <h2>De:</h2> : <></>}
                                                        <h3 >{item.preco_regular.toString().slice(0,-3)},</h3>
                                                        <h4>{item.preco_regular.toString().slice(-2)}</h4>
                                                        {exibeDePor ? <h2>Por:</h2> : <></>}
                                                        {exibeDePor ? <h3>{item.preco}</h3> : <></>}
                                                    </div>
                                                ):
                                                formato == 38 ? (
                                                    <div className={`item-baixo ${exibeDePor ? " diminuir" : ""}`}>
                                                        {<h2>De:</h2>}
                                                        <h3 >{item.preco.toString().slice(0,-3)},</h3>
                                                        <h4>{item.preco.toString().slice(-2)}</h4>
                                                        {<h2>Por:</h2>}
                                                        {<h3>{item.preco_promocional}</h3>}
                                                    </div>
                                                ):
                                                (formato == 32 || formato == 34 || formato == 36) ? 
                                                <div>
                                                    <h2>{item?.preco_regular?.toString()?.slice(0,-3)},{item?.preco_regular?.toString()?.slice(-2)}</h2>
                                                </div>
                                                :
                                                (formato == 33 || formato == 35) ?
                                                <div>
                                                    <h2>{item?.preco?.toString()?.slice(0,-3)},{item?.preco?.toString()?.slice(-2)}</h2>
                                                </div>
                                                :
                                                item.preco > 0 ? (
                                                <div className={`item-baixo ${exibeDePor ? " diminuir" : ""}`}>
                                                    {exibeDePor ? <h2>De:</h2> : <></>}
                                                    <h3 >{item.preco.toString().slice(0,-3)},</h3>
                                                    <h4>{item.preco.toString().slice(-2)}</h4>
                                                    {exibeDePor ? <h2>Por:</h2> : <></>}
                                                    {exibeDePor ? <h3>{item.preco_promocional}</h3> : <></>}
                                                </div>
                                                ):(
                                                <>
                                                    <div className='item-baixo'>
                                                        <h3>SEM PREÇO</h3>
                                                    </div>
                                                </>                                                
                                                )}
                                                {formato === 6 || formato === 7 || formato === 11 ? <h3 className='precoRegular'>{item.frase_destaque_rodape}</h3> : <></>}
                                                <div className={`textPeso ${exibeDePor ? " right" : ""}`}>
                                                </div>
                                                {formato === 13 && <span className='vigencia'>{item.vigencia}</span>}
                                            </div>
                                            {isKit && (
                                                <div className='alteraPreco alteraKit'>
                                                    <h3>DADOS DO KIT</h3>
                                                    <h5 className='label'>Valor do kit</h5>
                                                    <input className='inputAlterarPreco' type={'number'} placeholder={'Ex: 48,30'} value={valorKit(item, 'preco')} onChange={(e) => alteraCampoKit(item.id, 'preco', e.target.value)}/>
                                                    <h5 className='label'>Composição ({valorKit(item, 'composicao').length}/{LIMITE_COMPOSICAO})</h5>
                                                    <textarea
                                                        className='inputKitComposicao'
                                                        rows={4}
                                                        maxLength={LIMITE_COMPOSICAO}
                                                        placeholder={'Um produto por linha. Ex:\nCOXINHA DA ASA SWIFT 1Kg\nPÃO DE ALHO SWIFT 300g'}
                                                        value={valorKit(item, 'composicao')}
                                                        onChange={(e) => alteraCampoKit(item.id, 'composicao', e.target.value)}
                                                    />
                                                    <h5 className='label'>Validade da ação</h5>
                                                    <input className='inputAlterarPreco' type={'date'} value={valorKit(item, 'validade')} onChange={(e) => alteraCampoKit(item.id, 'validade', e.target.value)}/>
                                                </div>
                                            )}
                                            {!isKit && (!!prod?.activeEditPrice || formatosCampanhaComPrecoEditaveisSelecionado) && (
                                                <div className='alteraPreco'>
                                                    <h3>ALTERAR PREÇO</h3>
                                                    {exibeDePor ? <h5 className='label'>De:</h5> : <></>}
                                                    <input className='inputAlterarPreco' type={'number'} placeholder={'Ex: 89,99'} value={precoNovo}  onChange={(e) => setPrecoNovo(e.target.value)}/>
                                                    {exibeDePor ? <h5 className='label'>Por:</h5> : <></>}
                                                    {exibeDePor ? <input className='inputAlterarPreco' type={'number'} placeholder={'Ex: 89,99'} value={precoNovoPromocional}  onChange={(e) => setPrecoNovoPromocional(e.target.value)}/> : <></>}
                                                </div>
                                            )}
                                            <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                {isKit && (
                                                    <button className='modalPrecificador-preview-container-btn' onClick={()=>salvaKit(item)}>SALVAR</button>
                                                )}
                                                {!isKit && (!!prod?.activeEditPrice || formatosCampanhaComPrecoEditaveisSelecionado) && (
                                                    <button className='modalPrecificador-preview-container-btn' onClick={()=>alteraPrecoExecutado(item.id,precoNovo,precoNovoPromocional)}>SALVAR</button>
                                                )}
                                                <button className='modalPrecificador-preview-container-btn' onClick={()=>removeItem(item.id)}>REMOVER</button>
                                            </div>
                                        </div>
                                    )
                                }
                                return null;
                            })}
                        </div>
                    ) : <div className='container-vazio'>
                            <h1>Nenhum Item Adicionado</h1>
                        </div> 
                    }
                </div>
            </div>
        </div>
    )
}